import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rule-config" }
const _hoisted_2 = { class: "rule-inputs ion-padding" }
const _hoisted_3 = { slot: "label" }
const _hoisted_4 = { slot: "label" }
const _hoisted_5 = { class: "section-header" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "empty-state"
}

import { IonBackButton, IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonInput, IonItem, IonPage, IonNote, IonText, IonTitle, IonToggle, IonToolbar, onIonViewWillLeave, onIonViewDidEnter } from '@ionic/vue';
import { saveOutline } from 'ionicons/icons'
import { translate } from "@hotwax/dxp-components";
import ProductFilters from '@/components/ProductFilters.vue';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { RuleService } from '@/services/RuleService';
import { generateRuleActions, generateRuleConditions, hasError, showToast } from '@/utils';
import logger from '@/logger';
import router from '@/router';
import emitter from '@/event-bus';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateUpdateThresholdRule',
  props: ["ruleId"],
  setup(__props) {

const store = useStore();
const formData = ref({
  ruleName: '',
  threshold: '',
  selectedConfigFacilites: [],
  areAllChannelsSelected: false
}) as any;
const currentRule = ref({}) as any;
const props = __props;

const configFacilities = computed(() => store.getters["util/getConfigFacilities"])
const appliedFilters = computed(() => store.getters["util/getAppliedFilters"]);
const appliedFiltersOperator = computed(() => store.getters["util/getAppliedFiltersOperator"]);
const rules = computed(() => store.getters["rule/getRules"]);
const total = computed(() => store.getters["rule/getTotalRulesCount"])
const currentEComStore = computed(() => store.getters["user/getCurrentEComStore"])

onIonViewDidEnter(async () => {
  emitter.on("productStoreOrConfigChanged", redirectLink);
  emitter.emit("presentLoader");
  await store.dispatch("util/fetchConfigFacilities");

  if(props.ruleId) {
    try {
      const resp = await RuleService.fetchRules({ ruleId: props.ruleId })

      if(!hasError(resp)) {
        currentRule.value = resp.data[0];

        formData.value.ruleName = currentRule.value.ruleName;
        formData.value.threshold = currentRule.value.ruleActions[0]?.fieldValue ? currentRule.value.ruleActions[0].fieldValue : ''

        const facilityCondition = currentRule.value.ruleConditions.find((condition: any) => condition.conditionTypeEnumId === "ENTCT_ATP_FACILITIES")
        if(facilityCondition?.fieldValue === "ALL") formData.value.areAllChannelsSelected = true
        else formData.value.selectedConfigFacilites = facilityCondition?.fieldValue ? facilityCondition.fieldValue?.split(",") : [];

        const currentAppliedFilters = JSON.parse(JSON.stringify(appliedFilters.value))
        const currentAppliedFiltersOperator = JSON.parse(JSON.stringify(appliedFiltersOperator.value))
        currentRule.value.ruleConditions.map((condition: any) => {
          if(condition.conditionTypeEnumId === "ENTCT_ATP_FILTER") {
            if(condition.operator === "contains") {
              currentAppliedFilters["included"][condition.fieldName] = condition.fieldValue ? condition.fieldValue.split(",") : []
              currentAppliedFiltersOperator["included"][condition.fieldName] = condition.joinOperator || ""
            } else {
              currentAppliedFilters["excluded"][condition.fieldName] = condition.fieldValue ? condition.fieldValue.split(",") : []
              currentAppliedFiltersOperator["excluded"][condition.fieldName] = condition.joinOperator || ""
            }
          }
        })

        await store.dispatch('util/updateAppliedFilters', currentAppliedFilters)
        await store.dispatch('util/updateAppliedFiltersOperator', currentAppliedFiltersOperator)
      } else {
        throw resp.data
      }
    } catch(err: any) {
      logger.error(err);
    }
  }
  emitter.emit("dismissLoader");
})

onIonViewWillLeave(() => {
  formData.value = {
    ruleName: '',
    threshold: '',
    selectedConfigFacilites: []
  }
  store.dispatch("util/clearAppliedFilters")
  store.dispatch("util/clearAppliedFiltersOperator")
  emitter.off("productStoreOrConfigChanged", redirectLink);
})

async function redirectLink() {
  router.push("/threshold")
}

function toggleFacilitySelection(facilityId: any) {
  if(isFacilitySelected(facilityId)) {
    formData.value.selectedConfigFacilites = formData.value.selectedConfigFacilites.filter((currentFacilityId: string) => currentFacilityId !== facilityId)
  } else {
    formData.value.selectedConfigFacilites.push(facilityId)
  }
}

function isFacilitySelected(facilityId: any) {
  return formData.value.selectedConfigFacilites?.includes(facilityId)
}

async function createThresholdRule() {
  if(!isRuleValid()) return;

  emitter.emit("presentLoader");

  let ruleGroup = await store.dispatch("rule/fetchRuleGroup", { groupTypeEnumId: "RG_THRESHOLD" });

  try {
    if(!ruleGroup.ruleGroupId) {
      ruleGroup = await RuleService.createRuleGroup({
        "groupTypeEnumId": "RG_THRESHOLD",
        "productStoreId": currentEComStore.value.productStoreId,
        "statusId": "ATP_RG_ACTIVE"
      })
    }

    const params = {
      "ruleGroupId": ruleGroup.ruleGroupId,
      "ruleName": formData.value.ruleName,
      "statusId": "ATP_RULE_ACTIVE",
      "sequenceNum": total.value ? rules.value[total.value-1].sequenceNum + 1 : 1
    }

    const rule = await RuleService.createRule(params)

    await RuleService.updateRule({
      ...params,
      "ruleConditions": generateRuleConditions(rule.ruleId, "ENTCT_ATP_FACILITIES", appliedFilters.value, formData.value.selectedConfigFacilites, formData.value.areAllChannelsSelected, appliedFiltersOperator.value),
      "ruleActions": generateRuleActions(rule.ruleId, "ATP_THRESHOLD", formData.value.threshold, false, [])
    }, rule.ruleId);

    showToast(translate("Rule created successfully."))
    store.dispatch("rule/clearRuleState")
    store.dispatch("util/clearAppliedFilters")
    router.push("/threshold");
  } catch(err: any) {
    logger.error(err);
    showToast(translate("Failed to create rule."))
  }
  emitter.emit("dismissLoader");
}

async function updateRule() {
  if(!isRuleValid()) return;

  const currentRuleConditions = JSON.parse(JSON.stringify(currentRule.value.ruleConditions));
  const updatedRuleConditions = generateRuleConditions(props.ruleId, "ENTCT_ATP_FACILITIES", appliedFilters.value, formData.value.selectedConfigFacilites, formData.value.areAllChannelsSelected, appliedFiltersOperator.value);
  updatedRuleConditions.map((updatedCondition: any) => {
    const current = currentRuleConditions.find((condition: any) => condition.conditionTypeEnumId === updatedCondition.conditionTypeEnumId && condition.fieldName === updatedCondition.fieldName && condition.operator === updatedCondition.operator);
    if(current) updatedCondition["conditionSeqId"] = current.conditionSeqId;
  })

  const conditionsToRemove = currentRuleConditions.filter((condition: any) => !updatedRuleConditions.some((updatedCondition: any) => condition.conditionTypeEnumId === updatedCondition.conditionTypeEnumId && condition.fieldName === updatedCondition.fieldName && condition.operator === updatedCondition.operator && condition.conditionSeqId === updatedCondition.conditionSeqId))

  try {
    await RuleService.updateRule({
      ...currentRule.value,
      "ruleName": formData.value.ruleName,
      "ruleConditions": updatedRuleConditions,
      "ruleActions": generateRuleActions(props.ruleId, "ATP_THRESHOLD", formData.value.threshold, true, currentRule.value.ruleActions)
    }, props.ruleId);
    showToast(translate("Rule updated successfully."))

    const removeResponses = await Promise.allSettled(conditionsToRemove.map(async (condition: any) => await RuleService.deleteCondition({ ...condition, ruleId: props.ruleId})));
    const hasFailedResponse = removeResponses.some((response: any) => response.status === 'rejected');
    if(hasFailedResponse) logger.error("Failed to delete some rule conditions.")

    store.dispatch("rule/clearRuleState")
    store.dispatch("util/clearAppliedFilters")
    router.push("/threshold");
  } catch(err: any) {
    logger.error(err);
  }
}

function isRuleValid() {
  if(!formData.value.ruleName.trim() || !formData.value.threshold) {
    showToast(translate("Please fill in all the required fields."))
    return false;
  }
  if(formData.value.threshold < 0){
    showToast(translate("Threshold should be greater than or equal to 0."))
    return false;
  }
  if(!formData.value.areAllChannelsSelected && !formData.value.selectedConfigFacilites.length) {
    showToast(translate("Please select atleast one channel."))
    return false;
  }
  return true
}

function validateThreshold(event: any) {
  if(/[`!@#$%^&*()_+\-=\\|,.<>?~e]/.test(event.key) && event.key !== 'Backspace') event.preventDefault();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonBackButton), {
                slot: "start",
                "default-href": "/threshold"
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.ruleId ? _unref(translate)("Edit threshold rule") : _unref(translate)("New threshold rule")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(IonCard), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCardHeader), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCardTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Rule Configuration")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          modelValue: formData.value.ruleName,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.ruleName) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createTextVNode(_toDisplayString(_unref(translate)("Name")) + " ", 1),
                              _createVNode(_unref(IonText), { color: "danger" }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode("*", -1)
                                ]))]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          modelValue: formData.value.threshold,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.threshold) = $event)),
                          type: "number",
                          min: "0",
                          onKeydown: _cache[2] || (_cache[2] = ($event: any) => (validateThreshold($event)))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createTextVNode(_toDisplayString(_unref(translate)("Threshold")) + " ", 1),
                              _createVNode(_unref(IonText), { color: "danger" }, {
                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                  _createTextVNode("*", -1)
                                ]))]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", null, [
              _createTextVNode(_toDisplayString(_unref(translate)("Channels")) + " ", 1),
              _createVNode(_unref(IonText), { color: "danger" }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("*", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("section", null, [
            _createVNode(_unref(IonItem), { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonToggle), {
                  modelValue: formData.value.areAllChannelsSelected,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.areAllChannelsSelected) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Select all channels")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          (configFacilities.value.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configFacilities.value, (facility) => {
                  return (_openBlock(), _createBlock(_unref(IonCard), {
                    key: facility.facilityId,
                    onClick: ($event: any) => (toggleFacilitySelection(facility.facilityId)),
                    button: "",
                    disabled: formData.value.areAllChannelsSelected
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCardHeader), null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_unref(IonCardTitle), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(facility.facilityName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(IonCardSubtitle), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(facility.facilityId), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createVNode(_unref(IonCheckbox), {
                            checked: isFacilitySelected(facility.facilityId)
                          }, null, 8, ["checked"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(IonNote), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("No channel found for selected product store. Either change the product store or associate channels with the product store.")), 1)
                  ]),
                  _: 1
                })
              ])),
          _createVNode(ProductFilters)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFab), {
        vertical: "bottom",
        horizontal: "end",
        slot: "fixed"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonFabButton), {
            disabled: !configFacilities.value.length,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (currentRule.value.ruleId? updateRule() : createThresholdRule()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})